/*
 * Link del video della struttura: solo YouTube o Vimeo, le stesse forme che accettano il backend
 * (`libs/utils/src/video-link.ts`) e l'app (`VideoLink.parse`). Serve al controllo mentre si scrive e
 * all'anteprima; il controllo che conta lo rifa` il server.
 */

const YOUTUBE_ID = /^[\w-]{6,20}$/;
const VIMEO_ID = /^\d{5,12}$/;

export const leggiLinkVideo = (link) => {
    const testo = String(link || '').trim();
    if (!testo) return null;
    let url;
    try {
        url = new URL(/^https?:\/\//i.test(testo) ? testo : `https://${testo}`);
    } catch {
        return null;
    }
    const host = url.hostname.toLowerCase().replace(/^(www\.|m\.)/, '');
    const parti = url.pathname.split('/').filter(Boolean);
    if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
        const id = parti[0] === 'watch' ? url.searchParams.get('v') : ['shorts', 'embed', 'live'].includes(parti[0]) ? parti[1] : null;
        return id && YOUTUBE_ID.test(id) ? { provider: 'youtube', id } : null;
    }
    if (host === 'youtu.be') return parti[0] && YOUTUBE_ID.test(parti[0]) ? { provider: 'youtube', id: parti[0] } : null;
    if (host === 'vimeo.com') {
        const id = parti[0] === 'channels' ? parti[2] : parti[0];
        return id && VIMEO_ID.test(id) ? { provider: 'vimeo', id } : null;
    }
    if (host === 'player.vimeo.com') {
        const id = parti[0] === 'video' ? parti[1] : null;
        return id && VIMEO_ID.test(id) ? { provider: 'vimeo', id } : null;
    }
    return null;
};

export const indirizzoIncorporato = ({ provider, id }) =>
    provider === 'youtube' ? `https://www.youtube-nocookie.com/embed/${id}` : `https://player.vimeo.com/video/${id}`;
